export default __webpack_public_path__ + "static/web-analytics-dark-mode-a3efbca74633475015df61db642e923f.png";